function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M101.528,88.413c-3.348-3.234-8.671-3.188-11.962,0.104c-3.292,3.292-3.338,8.614-0.104,11.962l153.412,153.412 c2.143,2.218,5.315,3.108,8.299,2.327c2.984-0.781,5.313-3.111,6.094-6.094c0.781-2.984-0.109-6.156-2.327-8.299L101.528,88.413z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.58,45.464c-3.348-3.234-8.671-3.188-11.962,0.104c-3.292,3.292-3.338,8.614-0.104,11.962L64.92,75.954 c3.337,3.337,8.747,3.337,12.083,0c3.337-3.337,3.337-8.747,0-12.083L58.58,45.464z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470.39,425.599l-74.974-91.255l19.063-19.055c10.118-10.133,10.107-26.549-0.026-36.668 c-10.133-10.118-26.549-10.107-36.668,0.026l-17.698,17.69l-24.405-31.002l161.792-127.377c1.822-1.437,2.981-3.553,3.209-5.862 L513.057,9.394c-0.011-0.286-0.04-0.571-0.085-0.853c0.046-0.282,0.074-0.567,0.085-0.853c-0.066-0.275-0.148-0.546-0.247-0.811 c-0.109-0.557-0.278-1.1-0.503-1.621c-0.205-0.499-0.46-0.976-0.759-1.425c-0.307-0.442-0.659-0.851-1.05-1.22 c-0.377-0.39-0.795-0.739-1.246-1.041c-0.452-0.301-0.932-0.558-1.434-0.768c-0.513-0.21-1.044-0.373-1.587-0.486 c-0.307-0.06-0.555-0.23-0.853-0.265c-0.299-0.034-0.563,0.085-0.853,0.085s-0.555-0.128-0.853-0.085L380.969,12.338 c-2.309,0.228-4.426,1.386-5.862,3.209l-118.05,149.956L139.007,15.546c-1.437-1.822-3.553-2.981-5.862-3.209L10.443,0.05 c-0.299,0-0.563,0.085-0.853,0.085c-0.29,0-0.555-0.128-0.853-0.085C8.438,0.093,8.174,0.255,7.883,0.314 C7.372,0.419,6.872,0.574,6.39,0.775C5.832,1.001,5.299,1.287,4.803,1.629C4.418,1.912,4.055,2.226,3.719,2.567 C3.295,2.984,2.912,3.442,2.576,3.933C2.316,4.336,2.094,4.761,1.91,5.204c-0.239,0.548-0.416,1.12-0.529,1.707 C1.27,7.163,1.176,7.422,1.099,7.687c0.011,0.286,0.04,0.571,0.085,0.853C1.139,8.823,1.111,9.108,1.099,9.394l12.288,122.701 c0.228,2.309,1.386,4.426,3.209,5.862l161.835,127.437l-24.457,30.976l-17.732-17.732c-10.245-9.776-26.363-9.776-36.608,0 c-4.858,4.854-7.588,11.44-7.588,18.308c0,6.868,2.73,13.454,7.588,18.308l19.072,19.072l-74.982,91.273 C19.978,425.881,0.905,445.262,1,469.008c0.096,23.747,19.325,42.972,43.072,43.064s43.123-18.986,43.401-42.732l91.264-74.982 l19.072,19.072c10.139,9.936,26.387,9.855,36.426-0.182c10.039-10.037,10.124-26.285,0.19-36.426l-17.724-17.724l40.354-31.787 l40.354,31.77l-17.69,17.698c-7.387,7.404-9.604,18.52-5.625,28.191c3.979,9.672,13.377,16.008,23.835,16.071h0.085 c6.891,0.013,13.5-2.731,18.355-7.62l19.055-19.055l91.213,74.974c0.269,23.759,19.652,42.854,43.413,42.766 c23.761-0.088,43.002-19.326,43.095-43.086C513.24,445.259,494.15,425.872,470.39,425.599z M386.277,28.961l108.715-10.889 l-10.889,108.715L325.17,251.928l-11.477-14.583c-0.221-0.28-0.46-0.546-0.717-0.794l-10.743-13.653l122.394-122.394 c3.234-3.348,3.188-8.671-0.104-11.962s-8.614-3.338-11.962-0.104L291.6,209.398l-23.689-30.097L386.277,28.961z M62.813,487.261 c-10.224,10.223-26.8,10.223-37.024-0.001c-10.224-10.224-10.224-26.8,0-37.024c10.224-10.224,26.8-10.224,37.024-0.001 C73.014,460.468,73.014,477.027,62.813,487.261z M83.386,450.567c-2.082-4.619-4.972-8.829-8.533-12.433 c-3.604-3.562-7.814-6.451-12.433-8.533l68.412-83.14l35.772,35.772L83.386,450.567z M222.36,401.313 c-1.655,1.657-3.901,2.587-6.242,2.587c-2.342,0-4.587-0.931-6.242-2.587l-24.499-24.491l-49.092-49.092l-24.542-24.542 c-2.23-2.229-3.102-5.478-2.287-8.523c0.815-3.046,3.193-5.425,6.238-6.242c3.045-0.817,6.295,0.053,8.525,2.281l98.142,98.185 c3.43,3.451,3.43,9.024,0,12.476V401.313z M204.568,346.879l-19.191-19.191L166.16,308.47l25.711-32.589l45.73,36.002 c0.268,0.263,0.553,0.509,0.853,0.734l4.838,3.806L204.568,346.879z M249.735,299.792c-0.233-0.234-0.481-0.454-0.742-0.657 L30.01,126.787L19.122,18.072l108.715,10.889L300.21,247.883c0.198,0.258,0.415,0.5,0.649,0.725v0.051l16,20.326 c0.051,0.068,0.06,0.162,0.111,0.23s0.128,0.077,0.179,0.137l30.805,39.134l-19.217,19.2l-19.217,19.217L249.735,299.792z  M304.272,401.338c-1.663,1.678-3.927,2.621-6.289,2.62c-3.55-0.072-6.719-2.245-8.064-5.531s-0.611-7.057,1.869-9.599 l24.457-24.448l24.576-24.576l24.576-24.576l24.448-24.439c1.69-1.65,3.961-2.569,6.323-2.56c3.577-0.012,6.806,2.14,8.171,5.446 s0.594,7.109-1.95,9.624l-24.439,24.388l-0.077,0.051l-49.092,49.092l-0.043,0.068L304.272,401.338z M383.299,346.461 l68.369,83.217c-9.354,4.111-16.826,11.58-20.941,20.932l-83.217-68.361L383.299,346.461z M488.31,487.261 c-10.223,10.215-26.79,10.211-37.008-0.009c-10.218-10.22-10.218-26.788,0-37.008c10.218-10.22,26.785-10.224,37.008-0.009 C498.516,460.466,498.516,477.029,488.31,487.261z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.16,78.437c2.263,0,4.433-0.9,6.033-2.5L467.6,57.53c2.218-2.143,3.108-5.315,2.327-8.299 c-0.781-2.984-3.111-5.313-6.094-6.094c-2.983-0.781-6.156,0.109-8.299,2.327L437.11,63.871c-2.44,2.44-3.169,6.11-1.849,9.298 c1.32,3.188,4.431,5.267,7.882,5.268H443.16z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBattle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.148 512.148",
    style: {
      enableBackground: "new 0 0 512.148 512.148"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#795548"
    },
    points: "74.381,466.864 185.732,373.416 136.648,324.332 43.2,435.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00838F"
    },
    points: "177.318,332.746 201.894,357.322 255.057,315.423 268.454,304.927 268.454,304.842  321.702,262.943 490.235,130.25 502.523,7.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0D3F0"
    },
    points: "152.742,308.17 177.318,332.746 502.523,7.541 379.814,19.829 255.057,178.293  221.265,221.215 205.222,241.61 205.137,241.61 188.411,262.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00BCD4"
    },
    points: "177.318,332.746 152.742,308.17 188.411,262.943 205.137,241.61 205.222,241.61  221.265,221.215 255.057,178.293 379.814,19.829 502.523,7.541  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD834"
    },
    d: "M98.555,295.967c0.002,4.614,1.845,9.037,5.12,12.288l98.133,98.133 c6.786,6.786,17.79,6.786,24.576,0c6.786-6.786,6.786-17.79,0-24.576l-98.133-98.133c-4.978-4.961-12.45-6.442-18.944-3.755 C102.814,282.611,98.573,288.94,98.555,295.967z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDD834"
    },
    cx: 42.304,
    cy: 467.76,
    r: 34.714
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#795548"
    },
    points: "435.733,466.864 324.382,373.416 373.465,324.332 466.914,435.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00838F"
    },
    points: "332.795,332.746 308.219,357.322 255.057,315.423 241.659,304.927 241.659,304.842  188.411,262.943 19.878,130.25 7.59,7.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0D3F0"
    },
    points: "357.371,308.17 332.795,332.746 7.59,7.541 130.299,19.829 255.057,178.293  288.849,221.215 304.891,241.61 304.977,241.61 321.702,262.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00BCD4"
    },
    points: "332.795,332.746 357.371,308.17 321.702,262.943 304.977,241.61 304.891,241.61  288.849,221.215 255.057,178.293 130.299,19.829 7.59,7.541  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD834"
    },
    d: "M411.558,295.967c-0.002,4.614-1.845,9.037-5.12,12.288l-98.133,98.133 c-6.786,6.786-17.79,6.786-24.576,0c-6.786-6.786-6.786-17.79,0-24.576l98.133-98.133c4.978-4.961,12.45-6.442,18.944-3.755 C407.3,282.611,411.541,288.94,411.558,295.967z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDD834"
    },
    cx: 467.81,
    cy: 467.76,
    r: 34.714
  }))), _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattle);
export default __webpack_public_path__ + "static/media/battle.16c35298.svg";
export { ForwardRef as ReactComponent };